import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import './pom.css'
import logo from '../../../images/POMLogo.png'
import PlainButton from '../../../../../web/src/components/Controls/plainButton';

import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import LayoutActions from '../../../reducers/layoutRedux';
import MessagesActions from '../../../reducers/messagesRedux'
import { HeapEvents, trackEvent } from '../../../utils/AnalyticsUtil'

const POMSection = ({ firstName, layoutType, addOnProducts, taxState }) => {
    const dispatch = useDispatch();
    const onLearnMoreAboutPOMClicked = () => {
        window.open(T.translate('Common.POMMarkettingWebsite'))
        trackEvent(HeapEvents.BUTTON_POM_LEARN);
    };

    const taxYearsObj = useSelector(state => state.workflow && state.workflow.case_state && state.workflow.case_state.taxYears
        ? state.workflow.case_state.taxYears : [], shallowEqual)

    const message = T.translate('Messages.Labels.POMAskExpertMessage', { TaxProName: taxYearsObj[0]?.assigned_tax_pro?.name, FirstName: firstName })
    var isCaseEligibleForPom = addOnProducts.filter(product => product.name === 'POM').length > 0;
    const onAskExpertClicked = () => {
        dispatch(LayoutActions.setDashboardTab('messages'))
        dispatch(MessagesActions.setInputScreenShowing(true))
        dispatch(MessagesActions.setMessageInProgress(message))
        dispatch(MessagesActions.setMessageSendState(''))
        trackEvent(HeapEvents.BUTTON_POM_ASK_EXPERT);
    };

    const [shouldShowPOMAd, setShouldShowPOMAd] = useState(false);

    useEffect(() => {
        setShouldShowPOMAd(false)
        if (taxState.ticket_type.includes('RTE') && (taxState.ticketState.includes('_WORKING') || taxState.ticketState.includes('_DOCUMENT_REVIEW')) && taxState.workflow_state.upload_docs === 'Complete' && isCaseEligibleForPom)
            setShouldShowPOMAd(true) 
    }, [taxYearsObj, addOnProducts])

    return (
        <>
            {
                shouldShowPOMAd &&
                <div className={(layoutType === 'desktop' || layoutType === 'large_tablet') ? 'pom-section-container' : 'pom-section-container-mobile'}>
                        <div className={(layoutType === 'desktop' || layoutType === 'large_tablet') ? 'pom-section-title' : 'pom-section-title-mobile'}>
                            <div className={(layoutType === 'desktop' || layoutType === 'large_tablet') ? 'pom-section-logo-container' : 'pom-section-logo-container-mobile'}>
                                <img width='34.659px' height='37.6667px'src={logo} />
                        </div>
                            <div className={(layoutType === 'desktop' || layoutType === 'large_tablet') ? 'pom-section-title-text' : 'pom-section-title-text-mobile'}>{T.translate('WorkflowPanel.POM.title')}</div>
                    </div>
                        <div className={(layoutType === 'desktop' || layoutType === 'large_tablet') ? 'pom-section-label-container' : 'pom-section-label-container-mobile'}>
                        {T.translate('WorkflowPanel.POM.subtext')}
                    </div>                   
                        <div className={(layoutType === 'desktop' || layoutType === 'large_tablet') ? 'pom-learnMoreStyleDiv' : 'pom-learnMoreStyleDiv-mobile'}>
                            <div className={(layoutType === 'desktop' || layoutType === 'large_tablet') ? 'pom-learn-more-link-div' : 'pom-learn-more-link-div-mobile'}>
                                <span className={(layoutType === 'desktop' || layoutType === 'large_tablet') ? 'pom-learnMoreStyle' : 'pom-learnMoreStyle-mobile'} onClick={() => onLearnMoreAboutPOMClicked()}>
                                    {T.translate('WorkflowPanel.POM.learnAboutPOM')}
                                </span>
                            </div>  
                            <div className={(layoutType === 'desktop' || layoutType === 'large_tablet') ? 'pom-ask-expert-link-div' : 'pom-ask-expert-link-div-mobile'}>                                
                                <PlainButton labelKey='WorkflowPanel.POM.askExpert' onClick={onAskExpertClicked} inProgress={false} inverted={true} />
                            </div>
                    </div>
                </div>
            }
        </>
    )
}

POMSection.propTypes = {
    firstName: PropTypes.string.isRequired,
    layoutType: PropTypes.string.isRequired
}

export default POMSection;